// File: src/api/users.js

import client from './client';
import { getUserId, getAuthCode } from './authStorage';

/**
 * Fetch a paginated list of users from the server.
 * @param {number} page 
 * @param {number} perPage 
 * @returns {Promise<{ pagination: object, data: array }>}
 */
export async function fetchUsers(page = 1, perPage = 20) {
  const payload = {
    user_id:   getUserId(),
    auth_code: getAuthCode(),
    page,
    per_page: perPage
  };
  const { data } = await client.post('/fetch_users.php', payload);
  if (data.status !== 200) {
    throw new Error(data.message);
  }
  return {
    pagination: data.pagination,
    data:       data.data
  };
}
